if (!customElements.get('date-de-livraison')) {
document.addEventListener("DOMContentLoaded", () => {
                const daysAfterToday = 4; // Nombre de jours après aujourd'hui pour la livraison
                const today = new Date();
              
                // Fonction pour calculer la date de livraison en sautant le dimanche
                function calculateShippingDate(startDate, days) {
                  let deliveryDate = new Date(startDate);
                  let addedDays = 0;
              
                  while (addedDays < days) {
                    deliveryDate.setDate(deliveryDate.getDate() + 1); // Ajouter un jour
                    if (deliveryDate.getDay() !== 0) { // Exclure le dimanche (0 = dimanche)
                      addedDays++;
                    }
                  }
              
                  return deliveryDate;
                }
              
                // Calcul de la date de livraison
                const shipDate = calculateShippingDate(today, daysAfterToday);
              
                // Formater la date au format français
                const options = { weekday: 'short', day: 'numeric', month: 'long' };
                let formattedDate = shipDate.toLocaleDateString('fr-FR', options);
              
                // Ajouter une majuscule à la première lettre du mois
                formattedDate = formattedDate.replace(
                  /\b(\w)(\w+)/g,
                  (match, firstLetter, rest) => firstLetter.toUpperCase() + rest
                );
              
                // Mettre la date dans l'élément HTML
                document.getElementById('shipping-date').textContent = formattedDate;
              });
}